import React from 'react';

import { canCurrentUserSeeParapetLoads } from '../../../../store/selectors/parapetLoadSelectors';
import { useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function ParapetLoadsContainerMenu() {
  const currentUserCanSeeParapetLoads = useAppSelector(canCurrentUserSeeParapetLoads);
  if (!currentUserCanSeeParapetLoads) return null;

  return (
    <SceneMenuContent>
      <AddItemMenuItem type="parapetLoad" />
    </SceneMenuContent>
  );
}
